import config from "./config.json";
export const { serverPath, SITE_KEY, siteLogoutTime, monoLanguage, clientPath, VERSION_CHECK_INTERVAL, otpSeconds, captchaKey, passwordSeconds, hideMenu } =
  config[process.env.REACT_APP_NODE_ENV];
